import { CookieService } from 'project/services';
import { BaseComponent } from 'project/general';

export default class CookieSettingsComponent extends BaseComponent {
    static getNamespace() {
        return 'cookie-settings';
    }
    onInit() {

        window.addEventListener('CookieScriptLoaded', function () {
 
            window.CookieScript.instance.onAccept = function (data) {
                CookieService.setCmsCookieLevel(data.categories);
            }

            window.CookieScript.instance.onAcceptAll = function () {
                var categories = [];
                categories.push("functionality");
                categories.push("targeting");
                CookieService.setCmsCookieLevel(categories);
            }

            window.CookieScript.instance.onReject = function () {
                CookieService.setCmsCookieLevel();
            }

        });

    }

}
